import { render } from "./MobileEmptyLayout.vue?vue&type=template&id=9a906ad6"
import script from "./MobileEmptyLayout.vue?vue&type=script&lang=js"
export * from "./MobileEmptyLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../worktrees/adel01/tcd-userpage-new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__